import React, { useRef, useEffect } from "react";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Placeholder from "@tiptap/extension-placeholder";
import Underline from "@tiptap/extension-underline";
import Link from "@tiptap/extension-link";
import Image from "@tiptap/extension-image";
import TextAlign from "@tiptap/extension-text-align";
import { TextStyle } from "@tiptap/extension-text-style";
import Color from "@tiptap/extension-color";
import Highlight from "@tiptap/extension-highlight";
import FontFamily from "@tiptap/extension-font-family";
// import FontSize from "@tiptap/extension-text-style/dist/FontSize";
import MDEditorRoot from "components/MDEditor/MDEditorRoot";
import { useMaterialUIController } from "context";
// import Table from "@tiptap/extension-table";
// import TableRow from "@tiptap/extension-table-row";
// import TableCell from "@tiptap/extension-table-cell";
// import TableHeader from "@tiptap/extension-table-header";
import { TableKit } from "@tiptap/extension-table";

// import TextStyle from "@tiptap/extension-text-style";
// import FontFamily from "@tiptap/extension-font-family";
// import FontSize from "@tiptap/extension-text-style/dist/FontSize"; // ✅ use correct path
// import Color from "@tiptap/extension-color";
// import Underline from "@tiptap/extension-underline";
// import Link from "@tiptap/extension-link";
// import TextAlign from "@tiptap/extension-text-align";
// import Image from "@tiptap/extension-image";
import { Extension } from "@tiptap/core";
import "./index.css";
import TableChart from "@mui/icons-material/TableChart";

import {
  IconButton,
  Stack,
  Divider,
  Tooltip,
  MenuItem,
  Select,
  InputLabel,
} from "@mui/material";

import {
  FormatBold,
  FormatItalic,
  FormatUnderlined,
  StrikethroughS,
  Title,
  FormatListBulleted,
  FormatListNumbered,
  FormatQuote,
  FormatAlignLeft,
  FormatAlignCenter,
  FormatAlignRight,
  Undo,
  Redo,
  Link as LinkIcon,
  Image as ImageIcon,
  CleaningServices,
  FormatColorText,
  Highlight as HighlightIcon,
  FormatSize,
  FormatColorFill,
  Translate,
} from "@mui/icons-material";

function MDEditor({
  value = "",
  onChange,
  name = "desc",
  placeholder = "Start writing...",
  success = true,
}) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const fileInputRef = useRef();
  const FontSize = Extension.create({
    name: "fontSize",

    addOptions() {
      return {
        types: ["textStyle"],
      };
    },

    addGlobalAttributes() {
      return [
        {
          types: this.options.types,
          attributes: {
            fontSize: {
              default: null,
              parseHTML: (element) =>
                element.style.fontSize?.replace(/['"]+/g, ""),
              renderHTML: (attributes) => {
                if (!attributes.fontSize) return {};
                return {
                  style: `font-size: ${attributes.fontSize}`,
                };
              },
            },
          },
        },
      ];
    },
  });

  // const editor = useEditor({
  //   extensions: [
  //     StarterKit.configure({
  //       heading: { levels: [1, 2, 3] },
  //       link: false,
  //       underline: false,
  //     }),
  //     Underline,
  //     Link.configure({ openOnClick: true }),
  //     Image.configure({ inline: false }),
  //     TextAlign.configure({ types: ["heading", "paragraph"] }),
  //     Placeholder.configure({ placeholder }),
  //     TextStyle,
  //     Color,
  //     Highlight.configure({ multicolor: true }),
  //     FontFamily.configure({
  //       types: ["textStyle"],
  //     }),
  //     FontSize,
  //   ],
  //   content: value,
  //   onUpdate: ({ editor }) => {
  //     const html = editor.getHTML();
  //     if (onChange) onChange({ target: { name, value: html } });
  //   },
  // });

  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        heading: { levels: [1, 2, 3] },
        link: false,
        underline: false,
      }),
      Underline,
      Link.configure({ openOnClick: true }),
      Image.configure({ inline: false }),
      TextAlign.configure({ types: ["heading", "paragraph"] }),
      Placeholder.configure({ placeholder }),
      TextStyle,
      Color,
      Highlight.configure({ multicolor: true }),
      FontFamily.configure({ types: ["textStyle"] }),
      FontSize,

      // // ✅ TABLE EXTENSIONS
      // Table.configure({
      //   resizable: true,
      // }),
      // TableRow,
      // TableHeader,
      // TableCell,
      // ✅ TABLE SUPPORT (CORRECT)
      TableKit.configure({
        table: {
          resizable: true,
        },
      }),
    ],
    content: value,
    onUpdate: ({ editor }) => {
      const html = editor.getHTML();
      if (onChange) onChange({ target: { name, value: html } });
    },
  });

  useEffect(() => {
    if (editor && value !== editor.getHTML()) {
      editor.commands.setContent(value);
    }
  }, [value, editor]);

  if (!editor) return null;

  const addLink = () => {
    const url = prompt("Enter link URL");
    if (url) editor.chain().focus().setLink({ href: url }).run();
  };

  const addImage = (file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      const src = e.target.result;
      editor.chain().focus().setImage({ src }).run();
    };
    reader.readAsDataURL(file);
  };

  const cleanFormatting = () => {
    editor.chain().focus().clearNodes().unsetAllMarks().run();
  };

  const buttonStyle = (active) => ({
    color: active ? "#1976d2" : darkMode ? "#ccc" : "#555",
  });

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    addImage(file);
    e.target.value = ""; // reset file input
  };

  return (
    <MDEditorRoot ownerState={{ darkMode }}>
      {/* <Stack
        direction="row"
        spacing={0.5}
        alignItems="center"
        sx={{
          flexWrap: "wrap",
          border: "1px solid #ccc",
          borderBottom: "none",
          borderRadius: "8px 8px 0 0",
          backgroundColor: darkMode ? "#1e1e1e" : "#f9f9f9",
          p: 0.5,
        }}
      > */}
      <div className="editor-toolbar">
        {/* Font family */}
        <Select
          defaultValue="inherit"
          size="small"
          onChange={(e) =>
            editor.chain().focus().setFontFamily(e.target.value).run()
          }
          sx={{ minWidth: 120 }}
        >
          <MenuItem value="inherit">Default</MenuItem>
          <MenuItem value="Arial">Arial</MenuItem>
          <MenuItem value="Tahoma">Tahoma</MenuItem>
          <MenuItem value="Times New Roman">Times</MenuItem>
          <MenuItem value="Courier New">Courier</MenuItem>
          <MenuItem value="Amiri">Amiri (Arabic)</MenuItem>
        </Select>

        {/* Font size
        <Select
          defaultValue="16px"
          size="small"
          onChange={(e) =>
            // editor
            //   .chain()
            //   .focus()
            //   .setMark("textStyle", { fontSize: e.target.value })
            //   .run()
            editor.chain().focus().setFontSize(e.target.value).run()
          }
          sx={{ minWidth: 100 }}
        >
          {[12, 14, 16, 18, 20, 24, 28, 32].map((s) => (
            <MenuItem key={s} value={`${s}px`}>
              {s}px
            </MenuItem>
          ))}
        </Select> */}
        <select
          onChange={(e) =>
            editor
              .chain()
              .focus()
              .setMark("textStyle", { fontSize: e.target.value })
              .run()
          }
        >
          <option value="">Size</option>
          <option value="12px">12</option>
          <option value="14px">14</option>
          <option value="16px">16</option>
          <option value="18px">18</option>
          <option value="20px">20</option>
          <option value="24px">24</option>
          <option value="32px">32</option>
        </select>
        {/* Text color */}
        <Tooltip title="Text color">
          <IconButton size="small">
            <input
              type="color"
              onChange={(e) =>
                editor.chain().focus().setColor(e.target.value).run()
              }
              style={{
                width: 24,
                height: 24,
                border: "none",
                cursor: "pointer",
              }}
            />
          </IconButton>
        </Tooltip>

        {/* Highlight */}
        <Tooltip title="Highlight color">
          <IconButton size="small">
            <input
              type="color"
              onChange={(e) =>
                editor
                  .chain()
                  .focus()
                  .setHighlight({ color: e.target.value })
                  .run()
              }
              style={{
                width: 24,
                height: 24,
                border: "none",
                cursor: "pointer",
              }}
            />
          </IconButton>
        </Tooltip>

        <Divider orientation="vertical" flexItem />

        {/* Standard formatting */}
        <Tooltip title="Bold">
          <IconButton
            size="small"
            onClick={() => editor.chain().focus().toggleBold().run()}
            sx={buttonStyle(editor.isActive("bold"))}
          >
            <FormatBold />
          </IconButton>
        </Tooltip>
        <Tooltip title="Italic">
          <IconButton
            size="small"
            onClick={() => editor.chain().focus().toggleItalic().run()}
            sx={buttonStyle(editor.isActive("italic"))}
          >
            <FormatItalic />
          </IconButton>
        </Tooltip>
        <Tooltip title="Underline">
          <IconButton
            size="small"
            onClick={() => editor.chain().focus().toggleUnderline().run()}
            sx={buttonStyle(editor.isActive("underline"))}
          >
            <FormatUnderlined />
          </IconButton>
        </Tooltip>
        <Tooltip title="Strike">
          <IconButton
            size="small"
            onClick={() => editor.chain().focus().toggleStrike().run()}
            sx={buttonStyle(editor.isActive("strike"))}
          >
            <StrikethroughS />
          </IconButton>
        </Tooltip>

        <Divider orientation="vertical" flexItem />

        {/* Lists & Headings */}
        <Tooltip title="Heading">
          <IconButton
            size="small"
            onClick={() =>
              editor.chain().focus().toggleHeading({ level: 2 }).run()
            }
          >
            <Title />
          </IconButton>
        </Tooltip>
        <Tooltip title="Bullet List">
          <IconButton
            size="small"
            onClick={() => editor.chain().focus().toggleBulletList().run()}
          >
            <FormatListBulleted />
          </IconButton>
        </Tooltip>
        <Tooltip title="Numbered List">
          <IconButton
            size="small"
            onClick={() => editor.chain().focus().toggleOrderedList().run()}
          >
            <FormatListNumbered />
          </IconButton>
        </Tooltip>
        <Tooltip title="Quote">
          <IconButton
            size="small"
            onClick={() => editor.chain().focus().toggleBlockquote().run()}
          >
            <FormatQuote />
          </IconButton>
        </Tooltip>

        <Divider orientation="vertical" flexItem />

        {/* Alignment */}
        <Tooltip title="Align Left">
          <IconButton
            size="small"
            onClick={() => editor.chain().focus().setTextAlign("left").run()}
          >
            <FormatAlignLeft />
          </IconButton>
        </Tooltip>
        <Tooltip title="Align Center">
          <IconButton
            size="small"
            onClick={() => editor.chain().focus().setTextAlign("center").run()}
          >
            <FormatAlignCenter />
          </IconButton>
        </Tooltip>
        <Tooltip title="Align Right">
          <IconButton
            size="small"
            onClick={() => editor.chain().focus().setTextAlign("right").run()}
          >
            <FormatAlignRight />
          </IconButton>
        </Tooltip>

        <Divider orientation="vertical" flexItem />

        {/* Media & links */}
        <Tooltip title="Add Link">
          <IconButton size="small" onClick={addLink}>
            <LinkIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Add Image">
          <IconButton size="small" onClick={() => fileInputRef.current.click()}>
            <ImageIcon />
          </IconButton>
        </Tooltip>
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          onChange={handleFileUpload}
          style={{ display: "none" }}
        />

        <Divider orientation="vertical" flexItem />

        {/* Undo/Redo */}
        <Tooltip title="Undo">
          <IconButton
            size="small"
            onClick={() => editor.chain().focus().undo().run()}
          >
            <Undo />
          </IconButton>
        </Tooltip>
        <Tooltip title="Redo">
          <IconButton
            size="small"
            onClick={() => editor.chain().focus().redo().run()}
          >
            <Redo />
          </IconButton>
        </Tooltip>

        <Tooltip title="Clear formatting">
          <IconButton size="small" onClick={cleanFormatting}>
            <CleaningServices />
          </IconButton>
        </Tooltip>

        {/* RTL Toggle */}
        <Tooltip title="Toggle Direction">
          <IconButton
            size="small"
            onClick={() =>
              editor
                .chain()
                .focus()
                .setTextAlign(
                  editor.isActive({ textAlign: "right" }) ? "left" : "right"
                )
                .run()
            }
          >
            <Translate />
          </IconButton>
        </Tooltip>
        {/* </Stack> */}
        <Divider orientation="vertical" flexItem />

        <Tooltip title="Insert Table">
          <IconButton
            size="small"
            onClick={() =>
              editor
                .chain()
                .focus()
                .insertTable({ rows: 3, cols: 3, withHeaderRow: true })
                .run()
            }
          >
            <TableChart />
          </IconButton>
        </Tooltip>

        <Tooltip title="Add Column After">
          <IconButton
            size="small"
            onClick={() => editor.chain().focus().addColumnAfter().run()}
          >
            <TableChart />
          </IconButton>
        </Tooltip>

        <Tooltip title=" Delete Row">
          <IconButton
            size="small"
            onClick={() => editor.chain().focus().deleteRow().run()}
          >
            <TableChart />
          </IconButton>
        </Tooltip>

        <Tooltip title="Merge Cells">
          <IconButton
            size="small"
            onClick={() => editor.chain().focus().mergeCells().run()}
          >
            <TableChart />
          </IconButton>
        </Tooltip>

        <Tooltip title="Delete Table">
          <IconButton
            size="small"
            onClick={() => editor.chain().focus().deleteTable().run()}
          >
            <TableChart />
          </IconButton>
        </Tooltip>
      </div>

      {/* <div
        style={{
          minHeight: 250,
          border: "1px solid #ccc",
          borderRadius: "0 0 8px 8px",
          padding: 12,
          backgroundColor: darkMode ? "#121212" : "#fff",
          color: darkMode ? "#fff" : "#000",
        }}
      >
        <EditorContent editor={editor} />
      </div> */}
      <EditorContent
        editor={editor}
        className={success ? "tiptap" : "tiptaperror"}
      />
    </MDEditorRoot>
  );
}

export default MDEditor;
